import type {
  AxisCalibration,
  ChartCalibration,
  PixelPoint,
  SourcePoint,
} from './types';

export function axisValueToPixel(axis: AxisCalibration, value: number): number {
  const fraction =
    axis.scale === 'log10'
      ? (Math.log10(value) - Math.log10(axis.value_start)) /
        (Math.log10(axis.value_end) - Math.log10(axis.value_start))
      : (value - axis.value_start) / (axis.value_end - axis.value_start);
  return axis.pixel_start + fraction * (axis.pixel_end - axis.pixel_start);
}

export function axisPixelToValue(axis: AxisCalibration, pixel: number): number {
  const fraction =
    (pixel - axis.pixel_start) / (axis.pixel_end - axis.pixel_start);
  if (axis.scale === 'log10') {
    return 10 **
      (Math.log10(axis.value_start) +
        fraction *
          (Math.log10(axis.value_end) - Math.log10(axis.value_start)));
  }
  return axis.value_start + fraction * (axis.value_end - axis.value_start);
}

export function pixelPointToSource(
  calibration: ChartCalibration,
  pixel: PixelPoint,
): SourcePoint {
  return {
    x: axisPixelToValue(calibration.x_axis, pixel.x),
    y: axisPixelToValue(calibration.y_axis, pixel.y),
  };
}

export function sourcePointToPixel(
  calibration: ChartCalibration,
  source: SourcePoint,
): PixelPoint {
  return {
    x: axisValueToPixel(calibration.x_axis, source.x),
    y: axisValueToPixel(calibration.y_axis, source.y),
  };
}
